export default __webpack_public_path__ + "static/media/hemsruti1.7b058524.jpeg";